import {createPinia} from "pinia";
import {createApp} from 'vue';
import VIdle3 from 'v-idle-3';
import vSelect from 'vue-select';
import App from './App.vue'
import Spinner from '@/components/common/Spinner.vue';
import router from './router';
import '@/assets/scss/main.scss';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import {
    Dataset,
    DatasetItem,
    DatasetInfo,
    DatasetPager,
    DatasetSearch,
    DatasetShow,
} from 'vue-dataset';

export const app = createApp(App)

app.use(VIdle3);
app.use(createPinia());
app.use(router);

app.component('Dataset', Dataset);
app.component('DatasetItem', DatasetItem);
app.component('DatasetInfo', DatasetInfo);
app.component('DatasetPager', DatasetPager);
app.component('DatasetSearch', DatasetSearch);
app.component('DatasetShow', DatasetShow);
app.component('VSelect', vSelect);
app.component('Spinner', Spinner);

app.mount('#app')
